import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import Slider from 'react-slick';

import ReferralSmileJourneyCard from '../../components/revamp/referral-smile-journey-card';
import useI18n from '../../hooks/use-i18n';

import '../../styles/revamp/referral-smile-journey.scss';

const sliderSettings = {
  arrows: false,
  accessibility: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: false,
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1399.9,
      settings: {
        slidesToShow: 2.6
      }
    },
    {
      breakpoint: 986,
      settings: {
        slidesToShow: 2.25
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.15
      }
    }
  ]
};

const ReferralSmileJourneySection = (props) => {
  const { referralAmount } = props;

  const i18n = useI18n();

  const translations = i18n.t('referral').start_smile_journey_section;
  const stepTranslations = translations.steps;

  const cardContents = [
    {
      title: stepTranslations.step1.title,
      content: stepTranslations.step1.content
    },
    {
      title: stepTranslations.step2.title,
      content: stepTranslations.step2.content
    },
    {
      title: i18n.t('referral.start_smile_journey_section.steps.step3.title',
        { referred_amount: referralAmount.referredAmount }),
      content: stepTranslations.step3.content
    },
    {
      title: stepTranslations.step4.title,
      content: stepTranslations.step4.content
    }
  ];

  const getMaxHeight = () => {
    let maxHeight = 0;
    const cardTexts = document.querySelectorAll('.referral-smile-journey-card');
    cardTexts.forEach((text) => {
      // eslint-disable-next-line no-param-reassign
      text.style.minHeight = 0;
    });
    cardTexts.forEach((text) => {
      if (text.offsetHeight > maxHeight) {
        maxHeight = text.offsetHeight;
      }
    });
    cardTexts.forEach((text) => {
      // eslint-disable-next-line no-param-reassign
      text.style.minHeight = `${maxHeight}px`;
    });
  };

  useEffect(() => {
    setTimeout(() => {
      getMaxHeight();
    }, 200);
    window.addEventListener('resize', getMaxHeight);
    return () => {
      window.removeEventListener('resize', getMaxHeight);
    };
  }, []);

  return (
    <section className="referral-smile-journey-section">
      <h2
        data-key="referral::start_smile_journey_section::heading"
        data-lokalise=""
      >
        {translations.heading}
      </h2>
      <Slider {...sliderSettings} className="smile-journey-slider">
        {cardContents.map((content, index) => (
          <ReferralSmileJourneyCard key={content.title} content={content} step={index + 1} />
        ))}
      </Slider>
    </section>
  );
};

export default ReferralSmileJourneySection;

ReferralSmileJourneySection.propTypes = {
  referralAmount: PropTypes.shape({
    referrerAmount: PropTypes.string,
    referredAmount: PropTypes.string
  }).isRequired
};
